type SegmentedToggleProps<T extends string | number> = {
  value: T
  options: Array<{ value: T; label: string }>
  onChange: (value: T) => void
  ariaLabel: string
  fullWidth?: boolean
}

export default function SegmentedToggle<T extends string | number>({
  value,
  options,
  onChange,
  ariaLabel,
  fullWidth = false,
}: SegmentedToggleProps<T>) {
  return (
    <div
      className={`rounded-lg bg-gray-200 p-0.5 ${fullWidth ? 'flex w-full' : 'inline-flex shrink-0'}`}
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-medium transition-all ${
            fullWidth ? 'flex-1' : ''
          } ${
            value === opt.value
              ? 'bg-white text-brand-700 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
